// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__2umh1","wrapper":"Card_wrapper__3LSh_","heading":"Card_heading__1Chy8","subHeading":"Card_subHeading__dk4Dm"};